module.exports = new __parcel__URL__("base.eb0106c8.png").toString();